import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import moment from 'moment';
import {
    DeliveryListItem,
    DELIVERY_LIST_TABLE_COLUMNS,
    filterDeliveryLists,
} from '@/modules/Logistics/composables/LogisticsTableHelper';
import { downloadTableAsExcel } from '@/helpers/PrintHelper';

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryTable',
  props: {
    dataSource: null,
    searchQuery: null,
    loading: { type: Boolean }
  },
  emits: ["updateSearch", "row-click", "delete"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'updateSearch', value: string): void;
    (e: 'row-click', record: DeliveryListItem): void;
    (e: 'delete', ids: number[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    dataSource: DeliveryListItem[];
    searchQuery: string;
    loading: boolean;
};



// Emits


// State
const selectedRowKeys = ref<number[]>([]);

// Table columns
const columns = computed(() => {
    return DELIVERY_LIST_TABLE_COLUMNS();
});

// Computed
const filteredData = computed(() => {
    return filterDeliveryLists(props.dataSource, props.searchQuery);
});

// Row selection config
const rowSelection = computed(() => ({
    selectedRowKeys: selectedRowKeys.value,
    onChange: (keys: number[]) => {
        selectedRowKeys.value = keys;
    },
}));

// Methods
function handleSearchChange(e: any) {
    emit('updateSearch', e.target.value);
}

function customRow(record: DeliveryListItem) {
    return {
        on: {
            click: () => emit('row-click', record),
        },
        style: {
            cursor: 'pointer',
        },
    };
}

function handleDeleteSelected() {
    emit('delete', selectedRowKeys.value);
    selectedRowKeys.value = [];
}

function handleDownloadExcel() {
    downloadTableAsExcel(columns.value, filteredData.value, 'delivery-lists');
}

function rowClassName(record: DeliveryListItem) {
    const today = moment().format('DD.MM.YYYY');
    return record.date === today ? 'today-row' : '';
}

return { __sfc: true,props, emit, selectedRowKeys, columns, filteredData, rowSelection, handleSearchChange, customRow, handleDeleteSelected, handleDownloadExcel, rowClassName }
}

})